document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initParallaxHero();
  initComparadorSeleccion();
  initEntregaEstimada();
  initHeroCarrusel();
  initFaq();
  initAntesDespues();
});

function initAntesDespues() {
  document.querySelectorAll('[data-mt-antes-despues]').forEach(function (wrap) {
    var antes = wrap.querySelector('[data-mt-ad-antes]');
    var manija = wrap.querySelector('[data-mt-ad-manija]');
    var arrastrando = false;

    function actualizar(clientX) {
      var rect = wrap.getBoundingClientRect();
      var porcentaje = ((clientX - rect.left) / rect.width) * 100;
      porcentaje = Math.max(0, Math.min(100, porcentaje));
      antes.style.clipPath = 'inset(0 ' + (100 - porcentaje) + '% 0 0)';
      manija.style.left = porcentaje + '%';
    }

    wrap.addEventListener('pointerdown', function (e) {
      arrastrando = true;
      try { wrap.setPointerCapture(e.pointerId); } catch (err) {}
      actualizar(e.clientX);
    });
    wrap.addEventListener('pointermove', function (e) {
      if (!arrastrando) return;
      actualizar(e.clientX);
    });
    wrap.addEventListener('pointerup', function () { arrastrando = false; });
    wrap.addEventListener('pointercancel', function () { arrastrando = false; });
  });
}

function initFaq() {
  document.querySelectorAll('[data-mt-faq]').forEach(function (faq) {
    var items = faq.querySelectorAll('.mt-faq-item');
    items.forEach(function (item) {
      var boton = item.querySelector('[data-mt-faq-pregunta]');
      var respuesta = item.querySelector('[data-mt-faq-respuesta]');
      boton.addEventListener('click', function () {
        var abierto = item.classList.contains('mt-faq-item--abierto');
        items.forEach(function (i) {
          i.classList.remove('mt-faq-item--abierto');
          i.querySelector('[data-mt-faq-respuesta]').style.maxHeight = null;
        });
        if (!abierto) {
          item.classList.add('mt-faq-item--abierto');
          respuesta.style.maxHeight = respuesta.scrollHeight + 40 + 'px';
        }
      });
    });
  });
}

function initHeroCarrusel() {
  var carruseles = document.querySelectorAll('[data-mt-hero-carrusel]');
  carruseles.forEach(function (carrusel) {
    var slides = carrusel.querySelectorAll('.mt-hero-slide');
    var puntos = carrusel.querySelectorAll('[data-mt-hero-punto]');
    if (slides.length < 2) return;
    var actual = 0;

    function mostrar(indice) {
      actual = (indice + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('mt-hero-slide--activa', i === actual); });
      puntos.forEach(function (p, i) { p.classList.toggle('mt-hero-punto--activo', i === actual); });
    }

    var prev = carrusel.querySelector('[data-mt-hero-prev]');
    var next = carrusel.querySelector('[data-mt-hero-next]');
    if (prev) prev.addEventListener('click', function () { mostrar(actual - 1); });
    if (next) next.addEventListener('click', function () { mostrar(actual + 1); });
    puntos.forEach(function (p, i) { p.addEventListener('click', function () { mostrar(i); }); });

    var auto = null;
    function iniciarAuto() {
      if (auto) return;
      auto = setInterval(function () { mostrar(actual + 1); }, 5000);
    }
    function pausarAuto() {
      clearInterval(auto);
      auto = null;
    }
    iniciarAuto();
    carrusel.addEventListener('mouseenter', pausarAuto);
    carrusel.addEventListener('mouseleave', iniciarAuto);
  });
}

function initEntregaEstimada() {
  var els = document.querySelectorAll('[data-mt-entrega]');
  if (!els.length) return;
  els.forEach(function (el) {
    var min = parseInt(el.getAttribute('data-min'), 10) || 7;
    var max = parseInt(el.getAttribute('data-max'), 10) || 14;
    var locale = el.getAttribute('data-locale') || '';
    var texto = min + '-' + max + (locale === 'en' ? ' days' : ' días');
    var plantilla = el.getAttribute('data-plantilla') || 'Entrega estimada: {rango}';
    el.textContent = plantilla.replace('{rango}', texto);
  });
}

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function (el) { obs.observe(el); });
}

function initParallaxHero() {
  var img = document.querySelector('[data-mt-parallax]');
  if (!img || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.matchMedia('(max-width: 989px)').matches) return;
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var rect = img.closest('.mt-section').getBoundingClientRect();
      var offset = rect.top * -0.06;
      img.style.transform = 'translateY(' + offset.toFixed(1) + 'px) scale(1.04)';
      ticking = false;
    });
  }, { passive: true });
}

function initComparadorSeleccion() {
  var cards = document.querySelectorAll('.mt-comp-card');
  if (!cards.length) return;
  cards.forEach(function (card) {
    card.addEventListener('click', function (e) {
      if (e.target.closest('a') || e.target.closest('[data-mt-comp-swatches]')) return;
      cards.forEach(function (c) { c.classList.remove('mt-comp-card--activa'); });
      card.classList.add('mt-comp-card--activa');
    });

    var img = card.querySelector('[data-mt-comp-img]');
    var enlace = card.querySelector('[data-mt-comp-enlace]');
    var swatches = card.querySelectorAll('.mt-comp-swatch');
    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function (e) {
        e.stopPropagation();
        swatches.forEach(function (s) { s.classList.remove('mt-comp-swatch--activo'); });
        swatch.classList.add('mt-comp-swatch--activo');
        var color = swatch.getAttribute('data-color');
        if (img) img.src = color === 'negro' ? img.getAttribute('data-negro') : img.getAttribute('data-blanco');
        if (enlace) enlace.href = color === 'negro' ? enlace.getAttribute('data-negro') : enlace.getAttribute('data-blanco');
      });
    });
  });
}
